import { Box, Button, Typography } from "@mui/material"
import * as Sentry from "@sentry/react";

export const DevPage = () => {
  return (
    <Box sx={{
      height: '889px',//minHeight: '100vh',
      minWidth: '100%',
      display: 'flex',
      flexDirection: 'column',
      // gap: '20px',
      // padding: '0px 16px 16px 16px',
    }}>
      <Box sx={{ backgroundColor: 'white', margin: '0 16px 0 16px' }}>
        <div style={{ zIndex: 2, margin: '0px 16px 0px 16px', borderTop: '1px solid #EEE' }} />
      </Box>
      <Box sx={{ backgroundColor: 'white', margin: '0 16px 0 16px', borderRadius: '0 0 4px 4px', padding: '16px 24px', position: 'sticky', top: '65px', zIndex: '9' }}>
        <Typography sx={{ fontFamily: 'Roboto', fontSize: '24px', fontWeight: '500', lineHeight: '32px' }}>Разработка и тестирование</Typography>
      </Box>
      <Box sx={{ backgroundColor: "white", margin: '16px', padding: '16px 24px', borderRadius: '4px' }}>
        <Button
          sx={{
            padding: '10px 12px',
            backgroundColor: '#009FDA',
            borderRadius: '4px',
            textTransform: 'none',
            color: 'white',
            fontSize: '14px',
            fontWeight: 500,
            '&:hover': { backgroundColor: '#007DB8', boxShadow: 'none' }, boxShadow: 'none',
            height: '32px', lineHeight: '16px'
          }}
          onClick={() => {
            throw new Error('TEST')
          }}
        >
          Отправить ошибку sentry
        </Button>
      </Box>
    </Box>
  )
}